import React from 'react';
import { useLocation } from 'react-router-dom';

const NOISE = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='220' height='220'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const HIDDEN_PREFIXES = ['/inspo', '/admin', '/film/theatre'];

export const GrainOverlay = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <div
      aria-hidden="true"
      data-testid="grain-overlay"
      className="grain-overlay"
      style={{ backgroundImage: NOISE }}
    />
  );
};

export default GrainOverlay;
